// extracted by mini-css-extract-plugin
var _1 = "ChapterBarGraph__canvas--lwmaI";
var _2 = "ChapterBarGraph__label--EDge2";
var _3 = "ChapterBarGraph__main--UvqPb";
export { _1 as "canvas", _2 as "label", _3 as "main" }
